const PHONE_REGEX = /^(?:60|0)[0-9]{7,}$/;

customElements.define('custom-modal-phone-register', class extends HTMLElement {
  constructor() {
    super();
    this.validateMessages = JSON.parse(this.getAttribute('data-validate') ?? "{}");

    document.getElementById('PopupPhoneNumberVeriPhoneNumber').addEventListener('change', () => {
      const verificationCodeWrapper = document.getElementById("FormField-verificationCode")
      verificationCodeWrapper.querySelector('input').setAttribute('disabled', '');
      verificationCodeWrapper.querySelector('input').value = '';
      verificationCodeWrapper.querySelector('button').setAttribute('disabled', '');
    })

    this.handleSendOTP();
    this.handleVerifyOTP();
  }

  handleResetFields() {
    const modalId = this.getAttribute('data-popup-id');
    const modal = document.getElementById(modalId);

    const phoneFieldWrapper = modal.querySelector('#FormField-PopupPhoneNumberVeriPhoneNumber');
    phoneFieldWrapper.querySelector('input').focus();
    phoneFieldWrapper.querySelectorAll(".form-field__text").forEach(field => field.classList.add('hidden'));
    phoneFieldWrapper.querySelector('button').removeAttribute('disabled');

    const verificationCodeWrapper = modal.querySelector("#FormField-verificationCode")
    verificationCodeWrapper.querySelector('input').setAttribute('disabled', "");
    verificationCodeWrapper.querySelector('input').value = "";
    verificationCodeWrapper.querySelector('button').setAttribute('disabled', "");
    verificationCodeWrapper.querySelectorAll(".form-field__text").forEach(field => field.classList.add('hidden'));
  }

  handleSendOTP() {
    const sendOTPBtn = document.getElementById('PopupPhoneNumberVeriPhoneNumber-sendOTPBtn');

    sendOTPBtn.addEventListener('click', async (e) => {
      const phoneFieldWrapper = document.getElementById('FormField-PopupPhoneNumberVeriPhoneNumber');
      let phoneValue = phoneFieldWrapper.querySelector('input').value.trim();
      const errorPhoneField = phoneFieldWrapper.querySelector('.form-field__text--error');
      const successMessage = phoneFieldWrapper.querySelector('.form-field__text--success');

      if (!phoneValue) {
        errorPhoneField.classList.remove('hidden');
        successMessage.classList.add('hidden');
      } else {
        const phoneForValidation = phoneValue.replace('+', '');
        if (!PHONE_REGEX.test(phoneForValidation)) {
          errorPhoneField.innerHTML = this.validateMessages.phoneInvalid || 'The phone number is invalid.';
          errorPhoneField.classList.remove('hidden');
          successMessage.classList.add('hidden');
        } else {
          // 0이나 60으로 시작하면 제거
          let phoneToSend = phoneForValidation.replace(/^(0|60)/, '');

          if (window.phonePrefix) {
            phoneToSend = window.phonePrefix + phoneToSend;
          }

          const sendOTPSpinner = phoneFieldWrapper.querySelector('.loading__spinner');
          sendOTPSpinner.classList.remove('hidden');

          const customerExistedRes = await this.handleCheckCustomerExisted({
            mobileNo: phoneValue.replace(window.phonePrefix, '0'),
            email: document.getElementById('EditAccountEmail').value.trim(),
          })

          const isShopifyCustomerPhoneExisted = customerExistedRes.data.phone; // from Shopify

          if (isShopifyCustomerPhoneExisted) {
            errorPhoneField.innerText = this.validateMessages.phoneExisted;
            errorPhoneField.classList.remove('hidden');
            sendOTPSpinner.classList.add('hidden');

            successMessage.classList.add('hidden');
            return;
          }

          this.handleSendOTPRequest(phoneToSend)
            .then(res => {
              if (res?.smsStatus === 'MESSAGE_SENT') {
                successMessage.classList.remove('hidden');
                errorPhoneField.classList.add('hidden');
                const verificationCodeWrapper = document.getElementById("FormField-verificationCode")
                verificationCodeWrapper.querySelector('input').removeAttribute('disabled');
                verificationCodeWrapper.querySelector('input').focus();
                verificationCodeWrapper.querySelector('button').removeAttribute('disabled');
                const pinIdInput = document.getElementsByName('pinId');
                if (pinIdInput.length > 0) {
                  pinIdInput.value = res.pinId
                } else {
                  const form = document.getElementById('FormField-VerifyPhoneNumber');
                  const pinId = document.createElement('input');
                  pinId.type = 'hidden';
                  pinId.name = 'pinId';
                  pinId.value = res.pinId;
                  form.appendChild(pinId);
                }
              } else {
                sendOTPBtn.removeAttribute('disabled');
                errorPhoneField.innerText = this.validateMessages.codeSentFailed || 'Failed to send verification code. Please try again.';
                errorPhoneField.classList.remove('hidden');
                successMessage.classList.add('hidden');
              }
            })
            .catch((error) => {
              console.error('Error sending OTP:', error);
              sendOTPBtn.removeAttribute('disabled');
              errorPhoneField.innerText = this.validateMessages.codeSentFailed || 'Failed to send verification code. Please try again.';
              errorPhoneField.classList.remove('hidden');
              successMessage.classList.add('hidden');
            })
            .finally(() => {
              sendOTPSpinner.classList.add('hidden');
            })
        }
      }
    })
  }

  async handleSendOTPRequest(mobileNo) {
    const url = window.middlewareUrls.sendOTP + (window.isOTPTest ? '?mockInfobip=true' : '');
    try {
      let phone = mobileNo;
      if (!mobileNo.includes(window.phonePrefix)) {
        if (mobileNo.startsWith('+60')) {
          phone = mobileNo.replace('+60', window.phonePrefix);
        } else if (mobileNo.startsWith('60')) {
          phone = mobileNo.replace(/^60/, window.phonePrefix);
        } else {
          phone = window.phonePrefix + mobileNo.replace('+', '');
        }
      }
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ phoneNumber: phone })
      });
      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }
      const resJson = await response.json();
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  handleVerifyOTP() {
    const codeFieldWrapper = document.getElementById('FormField-verificationCode');

    codeFieldWrapper.getElementsByTagName('button')[0].addEventListener('click', () => {
      let codeValue = codeFieldWrapper.querySelector('input').value.trim();
      const errorCodeField = codeFieldWrapper.querySelector('.form-field__text--error');

      if (!codeValue) {
        errorCodeField.classList.remove('hidden');
      } else {
        const pin = codeFieldWrapper.querySelector('input').value.trim();
        const pinId = document.getElementsByName('pinId')[0].value;
        // const modal = document.querySelector('modal-opener');
        // const openModalBtn = modal.querySelector("button");
        const verificationCodeWrapper = document.getElementById("FormField-verificationCode");
        verificationCodeWrapper.querySelector("button").setAttribute('disabled', "");
        const spinner = verificationCodeWrapper.querySelector('.loading__spinner');
        spinner.classList.remove('hidden');
        this.handleVerifyOTPRequest(pin, pinId)
          .then((res) => {
            if (!!res?.verified) {
              const message = codeFieldWrapper.querySelector('.form-field__text--success');
              message.classList.remove('hidden');
              const errorMessages = codeFieldWrapper.querySelectorAll('.form-field__text--error');
              errorMessages.forEach(msg => msg.classList.add('hidden'));

              codeFieldWrapper.querySelector('input').removeAttribute('disabled');
              codeFieldWrapper.querySelector('button').removeAttribute('disabled');
              // openModalBtn.classList.add("hidden");

              document.querySelector('#FormField-editAccountPhoneNumber input').value = document
                .getElementById('FormField-PopupPhoneNumberVeriPhoneNumber')
                .querySelector('input')
                .value;
              document.querySelector('#FormField-editAccountPhoneNumber .form-field__text--error').classList.add('hidden');

              const phoneFieldWrapper = document.getElementById('FormField-PopupPhoneNumberVeriPhoneNumber');
              let phoneValue = phoneFieldWrapper.querySelector('input').value.trim();
              return this.handleCheckCustomerExisted({
                mobileNo: phoneValue.replace(window.phonePrefix, '0'),
                email: document.getElementById('EditAccountEmail').value.trim(),
              })
            } else {
              const message = codeFieldWrapper.querySelectorAll('.form-field__text--error')[1];
              message.classList.remove('hidden');
              return null;
            }
          })
          .then(res => {
            if (!res) return;
            const isPosCustomerExisted = res.data.mobileNo; // from POS
            if (isPosCustomerExisted) {
              const editAccountFormElm = document.querySelector('custom-edit-account-form');
              editAccountFormElm.handleSetInitData({
                ...res.data,
                email: document.getElementById('EditAccountEmail').value.trim(),
              });
            }
            this.handleCloseModal();
          })
          .catch((error) => {
            console.error('Error verifying OTP:', error);
            const message = codeFieldWrapper.querySelectorAll('.form-field__text--error')[1];
            message.classList.remove('hidden');
          })
          .finally(() => {
            spinner.classList.add('hidden');
            verificationCodeWrapper.querySelector("button").removeAttribute('disabled');
          })
      }
    })
  }

  async handleVerifyOTPRequest(pin, pinId) {
    const url = window.middlewareUrls.verifyOTP + (window.isOTPTest ? '?mockInfobip=true' : '');
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ pin, pinId })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }

  handleCloseModal() {
    const modalId = this.getAttribute('data-popup-id');
    const modal = document.getElementById(modalId);
    modal.hide();
  }

  async handleCheckCustomerExisted({ email = "", mobileNo = "" }) {
    const url = window.middlewareUrls.customerCheck;
    let mobileNoWithPhonePrefix = mobileNo
    const phonePrefixWithoutPlus = window.phonePrefix.replace('+', '');

    if ((/^0/.test(mobileNo))) {
      mobileNoWithPhonePrefix = `${window.phonePrefix}${mobileNo.slice(1)}`;
    } else if (mobileNo.startsWith(phonePrefixWithoutPlus)) {
      mobileNoWithPhonePrefix = `+${mobileNo}`;
    }

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, mobileNo: mobileNoWithPhonePrefix })
      });

      if (!response.ok) {
        throw new Error(`Response status: ${response.status}`);
      }

      const resJson = await response.json();
      return resJson;
    } catch (error) {
      console.error(error.message);
    }
  }
})